<div class="page-content min-h-100">
    <!-- <p-panel
        [header]="serviceRequest ? serviceRequest.id + ' (' + (serviceRequest.location?.name ?? '--') + ')' : '...'"
        class=""
    > -->

    <p-panel>
        <ng-template pTemplate="header">
            <div style="display: flex;" class="p-panel-title">
                <span class="text-bold">{{ serviceRequest?.id }}</span>
                <div style="display: flex; gap: 0.5rem; align-items: center">
                    @if (serviceRequest?.location) {
                        <span>{{ serviceRequest?.location?.name }}</span>
                        <p-button
                            severity="secondary"
                            size="small"
                            icon="pi pi-external-link"
                            (click)="openLocationModal()"
                        />
                    } @else {
                        <span><i>No location...</i></span>
                    }
                </div>
            </div>
        </ng-template>
        @if (showLoading) {
            <div class="text-center">
                <p-progressSpinner
                    styleClass="w-4rem h-4rem"
                    strokeWidth="4"
                    animationDuration="1.5s"
                ></p-progressSpinner>
                <div class="mt-2 mb-2">{{ loadingStr }}</div>
            </div>
        } @else {
            <p-tabs [(value)]="currentTab">
                <p-tablist>
                    <p-tab [value]="EServiceRequestTab.GENERAL" ariaLabel="General information tab"> General </p-tab>
                    <p-tab [value]="EServiceRequestTab.TASKS" ariaLabel="Tasks tab"> Tasks </p-tab>
                    <p-tab [value]="EServiceRequestTab.FILES" ariaLabel="Files tab"> Files </p-tab>
                    <p-tab [value]="EServiceRequestTab.OBJECT_STORE" ariaLabel="Object store tab"> Object Store </p-tab>
                </p-tablist>

                <!-- We dont use tabpanels to avoid on/off rapid cycles -->
                <p-tabpanels></p-tabpanels>
            </p-tabs>

            @switch (currentTab) {
                @case (EServiceRequestTab.GENERAL) {
                    @if (serviceRequest) {
                        <app-service-request-general-info
                            [serviceRequest]="serviceRequest"
                            [refreshTrigger$]="refreshStatistics$.asObservable()"
                        ></app-service-request-general-info>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Service request not found!</b></div>
                    }
                }
                @case (EServiceRequestTab.TASKS) {
                    @if (serviceRequest) {
                        <app-service-request-tasks
                            (taskChanged)="refreshStatistics$.next()"
                        ></app-service-request-tasks>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Service request not found!</b></div>
                    }
                }
                @case (EServiceRequestTab.FILES) {
                    @if (serviceRequest) {
                        <app-user-file-crud></app-user-file-crud>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Service request not found!</b></div>
                    }
                }
                @case (EServiceRequestTab.OBJECT_STORE) {
                    @if (serviceRequest) {
                        <app-object-store-entry-crud
                            [linkObjectType]="'service_request'"
                            [linkObjectUUID]="serviceRequest.uuid"
                            (objectStoreChanged)="refreshStatistics$.next()"
                        ></app-object-store-entry-crud>
                    } @else {
                        <div class="mb-4 mt-4 text-center"><b>Service request not found!</b></div>
                    }
                }
            }
        }
    </p-panel>
</div>
